import React from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { AppBar, ThemeProvider, Toolbar, useMediaQuery, useTheme } from '@mui/material';
// import FuseSearch from '@fuse/core/FuseSearch';
// import FuseShortcuts from '@fuse/core/FuseShortcuts';

import Icon from 'app/main/components/Icon';

import { selectToolbarTheme } from 'app/store/fuse/settingsSlice';
// import AdjustFontSize from '../../shared-components/AdjustFontSize';
// import ChatPanelToggleButton from '../../shared-components/chatPanel/ChatPanelToggleButton';
import ExitToDashboard from 'app/fuse-layouts/shared-components/ExitToDashboard';
import FullScreenToggle from '../../shared-components/FullScreenToggle';
// import LanguageSwitcher from '../../shared-components/LanguageSwitcher';
import LastActionsPanelToggleButton from '../../shared-components/lastActionsPanel/LastActionsPanelToggleButton';
import NavbarToggleButton from '../../shared-components/NavbarToggleButton';
import NavbarMobileToggleButton from '../../shared-components/NavbarMobileToggleButton';
import NotificationPanelToggleButton from '../../shared-components/notificationPanel/NotificationPanelToggleButton';
import QuickNotesPanelToggleButton from '../../shared-components/quickNotesPanel/QuickNotesPanelToggleButton';
import UserMenu from '../../shared-components/UserMenu';

function ToolbarLayout1({ className }: { className?: string }) {
	const theme = useTheme();
	const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

	const config = useSelector(({ fuse }: any) => fuse.settings.current.layout.config);
	const navbar = useSelector(({ fuse }: any) => fuse.navbar);
	const toolbarTheme = useSelector(selectToolbarTheme);

	return (
		<ThemeProvider theme={toolbarTheme}>
			<AppBar
				id="fuse-toolbar"
				className={clsx('relative z-20 flex shadow-md', className)}
				color="primary"
				position="static"
			>
				<Toolbar className="min-h-64 p-0">
					<div className="flex flex-1 items-center px-16">
						{config.navbar.display &&
							config.navbar.position === 'left' &&
							(isXlUp ? (
								<>
									{(config.navbar.style === 'style-3' || config.navbar.style === 'style-3-dense') && (
										<NavbarToggleButton className="mx-0 h-40 w-40 p-0" />
									)}
									{config.navbar.style === 'style-1' && !navbar.open && (
										<NavbarToggleButton className="mx-0 h-40 w-40 p-0">
											<Icon icon="menu" />
										</NavbarToggleButton>
									)}
								</>
							) : (
								<NavbarMobileToggleButton className="mx-0 h-40 w-40 p-0">
									<Icon icon="menu" />
								</NavbarMobileToggleButton>
							))}
						{/* <Hidden mdDown>
							<FuseShortcuts />
						</Hidden> */}
					</div>

					<div className="flex h-full items-center overflow-x-auto px-8">
						{(theme.logo || !!import.meta.env.VITE_LOGO) && isLgUp && (
							<img
								className="logo-icon h-32 w-auto px-8"
								src={theme.logo || import.meta.env.VITE_LOGO}
								alt="logo"
							/>
						)}

						{/* <LanguageSwitcher /> */}
						{/* <AdjustFontSize /> */}
						<FullScreenToggle />
						<ExitToDashboard />
						{/* <FuseSearch /> */}
						{/* <Hidden lgUp>
							<ChatPanelToggleButton />
						</Hidden> */}
						<LastActionsPanelToggleButton />
						<QuickNotesPanelToggleButton />
						<NotificationPanelToggleButton />
						<UserMenu />
					</div>

					{config.navbar.display && config.navbar.position === 'right' ? (
						isXlUp ? (
							!navbar.open && <NavbarToggleButton className="mx-0 h-40 w-40 p-0" />
						) : (
							<NavbarToggleButton className="mx-0 h-40 w-40 p-0 sm:mx-8" />
						)
					) : (
						<></>
					)}
				</Toolbar>
			</AppBar>
		</ThemeProvider>
	);
}

export default React.memo(ToolbarLayout1);
